import Vue from 'vue'
import Loading from '@/components/loading'
import {getStyle, setStyle, addClass, removeClass} from '@/utils/dom'

const Mask = Vue.extend(Loading)

const toggleLoading = (el, binding) => {
  if (binding.value) {
    Vue.nextTick(() => {
      el.originalPosition = getStyle(el, 'position') || 'static'
      if (el.domInserted) {
        removeClass(el.mask, 'hidden')
      } else {
        if (!['relative', 'absolute', 'fixed'].includes(el.originalPosition)) {
          setStyle(el, 'position', 'relative')
        }
        el.appendChild(el.mask)
        el.domInserted = true
      }
    })
  } else {
    el.domInserted && addClass(el.mask, 'hidden')
  }
}

export default {
  bind(el, binding) {
    const mask = new Mask({
      el: document.createElement('div')
    })
    el.instance = mask
    el.mask = mask.$el
    binding.value && toggleLoading(el, binding)
  },
  update(el, binding) {
    if (binding.oldValue !== binding.value) {
      toggleLoading(el, binding)
    }
  },
  unbind(el) {
    if (el.domInserted) {
      el.mask &&
      el.mask.parentNode &&
      el.mask.parentNode.removeChild(el.mask)
      toggleLoading(el, { value: false })
    }
    el.instance && el.instance.$destroy()
  }
}
